import { useEffect } from 'react';
import moment from 'moment';
import './EmployeeDetails.scss';
import { useQuery } from '@tanstack/react-query';
import { fetchEmployeeDetails } from '../../../../store/apis/employeeService';
import { showDueDate } from '../../common';

function EmployeeDetails({
  performanceHeader,
  isLoading,
  selectedPeriod,
  selectedEmployee,
  performanceDueDate,
}) {
  const { data: user, refetch: refetchEmployeeData } = useQuery({
    queryKey: ['employeeDetails', selectedEmployee?.value],
    queryFn: async () => {
      const res = await fetchEmployeeDetails({
        type: 'PROFILE',
        employeeId: selectedEmployee?.value?.trim(),
      });
      return res?.[0];
    },
    enabled: !!selectedEmployee?.value, // Only run query when we have an employee
  });

  // Add useEffect to trigger refetch when selectedEmployee changes
  useEffect(() => {
    if (selectedEmployee?.value) {
      refetchEmployeeData();
    }
  }, [selectedEmployee?.value, refetchEmployeeData]);

  const headerData = performanceHeader?.[0];
  const dueDateData = performanceDueDate?.result?.[0];

  if (isLoading) return <div>Loading...</div>;

  return (
    <div className="empDetails" title="Employee Details">
      <div className="detailRow">
        <div className="detailCol">
          <div className="detailTitle">Employee Name</div>
          <div className="detailData">{headerData?.EmpName?.trim()}</div>
        </div>
        <div className="detailCol">
          <div className="detailTitle">Job Title</div>
          <div className="detailData">{headerData?.Designation?.trim()}</div>
        </div>
        <div className="detailCol">
          <div className="detailTitle">Department</div>
          <div className="detailData">{`${headerData?.Department?.trim()} - ${user?.CostCenter}`}</div>
        </div>
        <div className="detailCol">
          <div className="detailTitle">Job Code</div>
          <div className="detailData">{headerData?.Clasification?.trim()}</div>
        </div>
      </div>
      <div className="detailRow">
        <div className="detailCol">
          <div className="detailTitle">Recruited Date</div>
          <div className="detailData">
            {moment(headerData?.DOJ?.trim()).format('DD/MM/YYYY')}
          </div>
        </div>
        <div className="detailCol">
          <div className="detailTitle">PCM Scheme</div>
          <div className="detailData">{headerData?.PCM?.trim() || '-'}</div>
        </div>
        <div className="detailCol">
          <div className="detailTitle">Review Period</div>
          <div className="detailData">{selectedPeriod}</div>
        </div>
        <div className="detailCol">
          <div className="detailTitle">Due Date</div>
          <div className="detailData">
            {showDueDate(headerData, dueDateData)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeDetails;
